import './App.css';
import React from 'react';
import favicon from "./images/favicon.ico"
import { Routes, Route, Navigate } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import Navbar from './Components/Navbar'
import Footer from './Components/Footer'
import Home from './Pages/homepage';
import LiaisonService from './Pages/Liaison_service';
import ComingSoon from './Components/ComingSoon';
import Insights from './Pages/insights'
import Career from './Pages/career'
import Contactus from './Pages/contact'
import PostProperty from './Pages/Post_property'
import About from './Pages/About';
import Articles from './Pages/Articles';
import Industries from './Pages/Industries';
import LegalService from './/Pages/Legal_service'
import Liaison_Microlanding from './Pages/Liasion/Micro_landing';
import Notfound from './Pages/Notfound';
import Blog_list from './Pages/Blog/Blog_list'
import BlogDescription from './Pages/Blog/Blog_Description';
import Primary from './Pages/Primary';
import B2B from './Pages/B2B';
import B2B_Sublanding from './Pages/B2B_Sublanding';
import Secondaryteam_landingpage from './Pages/Secondaryteam_landingpage';
import Primary_Filtered from './Pages/Primary_Filtered';
import Thankyou from './Pages/Thankyou';

import Property_filtering from './Pages/Property_filtering';
import Registration from './Pages/Registration';
import Survey from './Pages/Survey';
import ScrollToTop from './Components/ScrollToTop';
import Privacypolicy from './Pages/Privacypolicy';
import Agri_Property from './Pages/Agri_Property';


function App() {



  return (
    <>
  
      <ScrollToTop />
      <Navbar />

      <Routes>

        <Route path="/*" element={<Navigate to="/home" />} />
        <Route path='/industries' element={<B2B />} />
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/liaison" element={<LiaisonService />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/careers" element={<Career />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/postproperty" element={<PostProperty />} />
        <Route path='/comingsoon' element={<ComingSoon />} />
        <Route path='/residential' element={<Primary />} />
        <Route path='/:url' element={<Primary_Filtered />} />
        <Route path='/articles' element={<Articles />} />
        <Route path='/industries' element={<Industries />} />
        <Route path='/legal' element={<LegalService />} />
        <Route path='/liaison/:micro_id' element={<Liaison_Microlanding />} />
        <Route path='/industries/:micro_id' element={<B2B_Sublanding />} />
        <Route path='/notfound' element={<Notfound />} />
        <Route path='/blog' element={<Blog_list />} />
        <Route path='/blogdescription/:id' element={<BlogDescription />} />
        <Route path='/secondary' element={<Secondaryteam_landingpage />} />
        <Route path='/thank-you/:id?' element={<Thankyou />} />
        <Route path='/filter' element={<Property_filtering />} />
        <Route path='/registration' element={<Registration />} />
        <Route path="/agri-propertymanagement" element= {<Agri_Property/>} />
        <Route path="/digitalsurvey" element={<Survey />} />
        <Route path='/comingsoon' element={<ComingSoon />} />
        <Route path='/privacypolicy' element={<Privacypolicy/>}/>
      </Routes>
      <Footer />
    </>
  );
}

export default App;
